export default __webpack_public_path__ + "static/media/login-pattern.ba599810.png";